<template>
  <div id="CoImportModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">ケアオケ登録情報をインポート</p>
      </header>
      <section class="modal-card-body">
        <div id="item-contens">
          <template v-for="(coinfo, index) in data" >
            <div class="card-content" :key="index" style="margin-bottom: 5px;">
              <table>
                <tr>
                    <td colspan="2">
                      <div class="columns">
                        <div class="column"></div>
                        <div class="column" style="text-align: center; font-size:20px;">施設情報 {{index + 1}} </div>
                        <div class="column" style="padding-right: 0px;">
                          <b-button v-if="index > 0"
                            style="float:right; width:27px; height:27px; border:none;"
                            icon-left="close-box-outline"
                            @click="deleteCoInfo(index)"></b-button>
                        </div>
                      </div>
                    </td>
                </tr>
                <tr>
                  <th colspan="2">
                    <b-button type="is-primary"
                      style="float:right;height:27px; width:260px; height:27px;"
                      @click="clipboardPasteInstitution(coinfo)">施設情報を貼り付ける
                    </b-button>
                  </th>
                </tr>
                <tr>
                  <th>医療機関名<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.medicalInstitutionName" class="validate" :name="(index+1)+'番目の医療機関名'" validate="required" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>診療科名</th>
                  <td><input type="text" v-model="coinfo.department" class="" :name="(index+1)+'番目の診療科名'" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>Shiip<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.shiip" class="validate" :name="(index+1)+'番目のShiip'" validate="required|numeric" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>Sold<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.sold" class="validate" :name="(index+1)+'番目のSold'" validate="required|numeric" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>郵便番号<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      v-model="coinfo.postcode"
                      class="validate"
                      :class="{'border-red': coinfo.invalidPostcode}"
                      :name="(index+1)+'番目の郵便番号'"
                      validate="required|numeric"
                      maxlength="7"
                      :placeholder="postcodePlaceholder"
                    />
                    <div v-if="coinfo.invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                  </td>
                </tr>
                <tr>
                  <th>都道府県<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.prefecture" class="validate" :name="(index+1)+'番目の都道府県'" validate="required" maxlength="4"/></td>
                </tr>
                <tr>
                  <th>市町村区<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.city" class="validate" :name="(index+1)+'番目の市町村区'" validate="required" maxlength="20"/></td>
                </tr>
                <tr>
                  <th>住所1<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.address1" class="validate" :name="(index+1)+'番目の住所1'" validate="required" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>住所2</th>
                  <td><input type="text" v-model="coinfo.address2" :name="(index+1)+'番目の住所2'" maxlength="100"/></td>
                </tr>
                <tr>
                  <th>電話番号<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      v-model="coinfo.telephone"
                      class="validate"
                      :class="{'border-red': coinfo.invalidPhoneNumber}"
                      :name="(index+1)+'番目の電話番号'"
                      validate="required|numeric"
                      maxlength="11"
                      :placeholder="phonePlaceholder"
                    />
                    <div v-if="coinfo.invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                  </td>
                </tr>
                <tr>
                  <th>クライアント認証<span class="require" /></th>
                  <td>
                    <select v-model="coinfo.certificationFlag" class="validate" :name="(index+1)+'番目のクライアント認証'" validate="required">
                      <option value=""/><option :value="true">有効にする</option><option :value="false">有効にしない</option>
                    </select>
                  </td>
                </tr>
                <tr v-if="isDealer">
                  <th>フィリップス保守サービス</th>
                  <td>
                    <select v-model="coinfo.crossReference" class="" :name="(index+1)+'番目のフィリップス保守サービス'">
                      <option value=""/><option :value="true">有</option><option :value="false">無</option>
                    </select>
                  </td>
                </tr>
                <tr v-if="isDealer">
                  <th>担当支店<span class="require" /></th>
                  <td>
                    <select v-model="coinfo.salesOffice" class="validate" :name="(index+1)+'番目の担当支店'" maxlength="100" validate="required">
                      <option v-for="branch of branchOfficeMaster" :value="branch.code" :key="'d' + branch.code">
                        {{branch.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>登録担当者ユーザー名<span class="require" /></th>
                  <td><input type="text" v-model="coinfo.registedCoUserId" class="validate" :name="(index+1)+'番目の登録担当者ユーザー名'" validate="required" maxlength="100"/></td>
                </tr>
                <tr>
                  <th style="vertical-align: top;">ユーザー情報</th>
                  <td>
                    <template v-for="(userInfo, index2) in coinfo.userList" >
                      <div class="card-content" :key="index2" style="margin-bottom: 5px;">
                        <table class="userTable">
                          <tr>
                              <td colspan="2">
                                <div class="columns">
                                  <div class="column"></div>
                                  <div class="column" style="text-align: center; font-size:20px;">ユーザー情報 {{index2 + 1}} </div>
                                  <div class="column" style="padding-right: 0px;">
                                    <b-button v-if="index2 > 0"
                                      style="float:right; width:27px; height:27px; border:none;"
                                      icon-left="close-box-outline"
                                      @click="deleteUser(coinfo.userList, index2)"></b-button>
                                  </div>
                                </div>
                              </td>
                          </tr>
                          <tr>
                            <th colspan="2">
                              <b-button type="is-primary"
                                style="float:right;height:27px; width:260px; height:27px;"
                                @click="clipboardPasteUser(userInfo)">ユーザー情報を貼り付ける
                              </b-button>
                            </th>
                          </tr>
                          <tr>
                            <th>COユーザーID<span class="require" /></th>
                            <td><input type="text" v-model="userInfo.registedCoUserId" class="validate" :name="(index+1)+'-'+(index2+1)+'番目のCOユーザーID'" validate="required" maxlength="100"/></td>
                          </tr>
                          <tr>
                            <th>メールアドレス</th>
                            <td><input type="text" v-model="userInfo.mail" class="validate" :name="(index+1)+'-'+(index2+1)+'番目のメールアドレス'" validate="mail" maxlength="256"/></td>
                          </tr>
                          <tr>
                            <th>氏名<span class="require" /></th>
                            <td>
                              <input type="text" style="width:215px;" v-model="userInfo.familyName" class="validate" :name="(index+1)+'-'+(index2+1)+'番目の姓'" validate="required" maxlength="100" placeholder="姓"/>
                              <input type="text" style="width:215px; margin-left:3px;" v-model="userInfo.firstName" class="validate" :name="(index+1)+'-'+(index2+1)+'番目の名'" validate="required" maxlength="100" placeholder="名"/>
                            </td>
                          </tr>
                          <tr v-if="isDealer">
                            <th>ユーザー区分</th>
                            <td>
                              <select v-model="userInfo.userDivision" :name="(index+1)+'-'+(index2+1)+'番目のユーザー区分'">
                                <option value=""/><option value="医療施設">医療施設</option><option value="ディーラー">ディーラー</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>処方設定<span class="require" /></th>
                            <td>
                              <select v-model="userInfo.prescriptionSettingsValidFlag" class="validate" :name="(index+1)+'-'+(index2+1)+'番目の処方設定'" validate="required">
                                <option value=""/><option :value="true">操作可</option><option :value="false">操作不可</option>
                              </select>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </template>
                    <div class="addButtonArea">
                      <b-button @click="addUser(coinfo.userList)" >ユーザーを追加する</b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </template>
          <div v-if="isDealer" class="addButtonArea">
            <b-button @click="addCoinfo">施設を追加する</b-button>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" v-on:click="importCo()" >インポート</button>
        <button class="button" type="button" style="width:200px;" v-on:click="notImportCo()" >インポートせずに完了</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
} from "@/components/mock/base/const.js";

// ユーザー情報
const userInitialValue = {
  // COユーザーID
  registedCoUserId: "",
  // メールアドレス
  mail: "",
  // 姓
  familyName: "",
  // 名
  firstName: "",
  // ユーザー区分
  userDivision: "",
  // 処方設定
  prescriptionSettingsValidFlag: false,
};

// 施設情報
const careOrchestratorInitialValue = {
  // 医療機関名
  medicalInstitutionName: "",
  // 診療科名
  department: "",
  // Shiip
  shiip: "",
  // Sold
  sold: "",
  // 郵便番号
  postcode: "",
  // 都道府県
  prefecture: "",
  // 市町村区
  city: "",
  // 住所1
  address1: "",
  // 住所2
  address2: "",
  // 電話番号
  telephone: "",
  // クライアント認証
  certificationFlag: false,
  // フィリップス保守サービス
  crossReference: false,
  // 担当支店
  salesOffice: "",
  // 登録担当者ユーザー名
  registedCoUserId: "",
  // ユーザー情報
  userList: [{ ...userInitialValue }],
  // 郵便番号入力におけるエラー判定
  invalidPostcode: false,
  // 電話番号入力におけるエラー判定
  invalidPhoneNumber: false,
};

export default {
  name: "CoImportModal",
  props: {
    isDealer:{type:Boolean, default: false, },
    belongId:{type:Number, default: 0, },
  },
  methods: {
    importCo: function() {
      if(this.checkInput()){
        this.$dialog.confirm({
          title: "　",
          confirmText:"はい",
          cancelText: "キャンセル",
          message:
            "ケアオケ登録情報をインポートしますか？",
          cancelConfirm: () => {
            return;
          },
          onConfirm: () => {
            // インポート処理実行
            var _this = this;
            var body = this.createBody();
            this.apiCall(
              function(client){
                return  client.apis.internalCo.coInfoImportPOST({
                  body:body
                });
              },
              async function(result){
                _this.showSuccess(result, function(){
                  //前画面を再描画して前画面に戻る
                  _this.$emit('reload');
                  _this.$parent.close();
                });
              },
              function(result){
                _this.showErrorMessage(result);
              }
            );
          }
        });
      }
    },
    notImportCo: function() {
      this.$dialog.confirm({
        title: "　",
        confirmText:"はい",
        cancelText: "キャンセル",
        message:
          "インポートせずに完了しますか？",
        cancelConfirm: () => {
          return;
        },
        onConfirm: () => {
          // インポートなし完了処理実行
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return  client.apis.internalCo.coInfoNotImportPOST({
                body:body
              });
            },
            async function(result){
              _this.showSuccess(result, function(){
                //前画面を再描画して前画面に戻る
                _this.$emit('reload');
                _this.$parent.close();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    checkInput: function() {
      //入力チェック
      let ret = false;
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        //エラーなし
        ret = true;
      }
      return ret;
    },
    createBody: function(){
      return {
        coInfo:JSON.parse(JSON.stringify(this.data)),
        belongId:this.belongId,
      }
    },
    addCoinfo: function() {
      this.data.push({ ...careOrchestratorInitialValue });
    },
    deleteCoInfo: function(index){
      this.data.splice(index, 1);
    },
    addUser: function(userInfoList) {
      userInfoList.push({ ...userInitialValue });
    },
    deleteUser: function(userInfoList, index){
      userInfoList.splice(index, 1);
    },
    clipboardPasteInstitution: function(institution){
      navigator.clipboard.readText().then((text) => {
        if(text != ""){
          let str = text.split("\r\n");
          str = str[0].split("\t");
          str[0] ? institution.medicalInstitutionName = str[0]:institution.medicalInstitutionName = "";
          str[1] ? institution.department = str[1]:institution.department = "";
          str[2] ? institution.shiip = str[2]:institution.shiip = "";
          str[3] ? institution.sold = str[3]:institution.sold = "";
          str[4] ? institution.postcode = str[4]:institution.postcode = "";
          str[5] ? institution.prefecture = str[5]:institution.prefecture = "";
          str[6] ? institution.city = str[6]:institution.city = "";
          str[7] ? institution.address1 = str[7]:institution.address1 = "";
          str[8] ? institution.address2 = str[8]:institution.address2 = "";
          str[9] ? institution.telephone = str[9]:institution.telephone = "";
          if(str[10] == "有効にする" || str[10] == "有効にしない"){
            institution.certificationFlag = (str[10] == "有効にする");
          } else {
            institution.certificationFlag = false;
          }
          if(str[11] == "有" || str[11] == "無"){
            institution.crossReference = (str[11] == "有");
          } else {
            institution.crossReference = false;
          }
          str[12]? institution.salesOffice = str[12]:institution.salesOffice = "";
          str[13]? institution.registedCoUserId = str[13]:institution.registedCoUserId = "";
        } else {
          this.showMessage("クリップボードからデータが取得できませんでした。")
        }
      });
    },
    clipboardPasteUser: function(user){
      navigator.clipboard.readText().then((text) => {
        if(text != ""){
          let str = text.split("\r\n");
          str = str[0].split("\t");
          str[0] ? user.registedCoUserId = str[0]:user.registedCoUserId = "";
          str[1] ? user.mail = str[1]:user.mail = "";
          str[2] ? user.familyName = str[2]:user.familyName = "";
          str[3] ? user.firstName = str[3]:user.firstName = "";
          str[4] ? user.userDivision = str[4]:user.userDivision = "";
          if(str[4] == "医療施設" || str[4] == "ディーラー"){
            user.prescriptionSettingsValidFlag = str[4];
          } else {
            user.prescriptionSettingsValidFlag = "";
          }
          if(str[5] == "操作可" || str[5] == "操作不可"){
            user.prescriptionSettingsValidFlag = (str[5] == "操作可");
          } else {
            user.prescriptionSettingsValidFlag = false;
          }
        } else {
          this.showMessage("クリップボードからデータが取得できませんでした。")
        }
      });
    },
  },
  data() {
    var branchOfficeMaster = this.getBranchOfficeMaster();
    branchOfficeMaster.unshift({});
    return {
      data: [{ ...careOrchestratorInitialValue }],
      branchOfficeMaster,
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidPostcode = isNaN(Number(value.postcode));
          value.invalidPhoneNumber = isNaN(Number(value.telephone));
        });
      },
      deep: true,
    }
  },
};
</script>
<style lang="scss" scoped>
#item-contens table tr th {
  width: 200px !important;
}
#item-contens .userTable tr th {
  width: 150px !important;
}
.addButtonArea {
  text-align: center;
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/common/CoImportModal.vue